module.exports = __webpack_public_path__ + "loader.862d2ee6a80411e84ede.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/opentok/loader.svg
// module id = ./src/assets/opentok/loader.svg
// module chunks = 2